"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const translationContext_1 = require("configs/translationContext");
const mobx_react_1 = require("mobx-react");
const classTag_1 = __importDefault(require("./classTag"));
const mapStateToProps = (stores, props) => ({
    quizDetails: (props.dripping.pageId &&
        stores.DrippingFormStore.quizDetails.get(props.dripping.pageId)) ||
        null
});
const DrippingClassesDetails = ({ dripping, quizDetails }) => {
    const { t } = (0, translationContext_1.useTranslation)();
    const { pageId, classes } = dripping;
    const pageClasses = quizDetails === null || quizDetails === void 0 ? void 0 : quizDetails.classes;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [classes.length === 0 && ((0, jsx_runtime_1.jsx)(classTag_1.default, { name: t('dripping_2.columns.classes.all'), tooltip: t('dripping_2.new.bulk_action.review.all_classes_warning', {
                    fallback: 'dripping_2.new.release_and_expiration.release.items.quiz.available_classes'
                }), isMarked: Boolean(dripping.pageId &&
                    quizDetails &&
                    quizDetails.allClassesAllowed === false) })), classes.map(({ hashId, name, defaultClass }) => {
                const isMarked = pageId && pageClasses ? !pageClasses.includes(hashId) : false;
                return ((0, jsx_runtime_1.jsx)(react_1.Fragment, { children: (0, jsx_runtime_1.jsx)(classTag_1.default, { name: name, tooltip: t('dripping_2.new.bulk_action.review.class_warning'), isMarked: isMarked, isDefault: defaultClass }) }, hashId));
            })] }));
};
exports.default = (0, mobx_react_1.inject)(mapStateToProps)(DrippingClassesDetails);
